import React from 'react'
import { AppPage } from '../layouts/types';

const PlayGround:AppPage = () => {
  

    return(  <div className="h-screen">
           
    </div>
  );
};

export default PlayGround;